module.exports = __webpack_public_path__ + "static/scale-model-of-space-needle-in-seattle-washington-bf30b0e841d12299336a9f1a7deee310.png";